/* eslint-disable banhammer/no-restricted-functions */
import * as Cookies from 'js-cookie'

import {
  Consent,
  consented,
  userHasOptedOutOfCookiesForCategory
} from './consent'

interface ICookieOptions {
  [key: string]: string | number
}

export const getCookie = ({
  itemKey,
  consentType,
  defaultValue
}: {
  itemKey: string
  consentType: Consent
  defaultValue?: string
}) => {
  if (consented(consentType)) {
    return Cookies.get(itemKey) || defaultValue
  }

  return defaultValue
}

export const setCookie = ({
  itemKey,
  itemValue,
  consentType,
  cookieOptions
}: {
  itemKey: string
  itemValue: string
  consentType: Consent
  cookieOptions?: ICookieOptions
}) => {
  if (consented(consentType)) {
    Cookies.set(itemKey, itemValue, cookieOptions)
  }
}

export const removeCookie = ({
  itemKey,
  cookieOptions
}: {
  itemKey: string
  cookieOptions?: ICookieOptions
}) => {
  Cookies.remove(itemKey, cookieOptions)
}

export const getExperimentCookieName = (experimentId: string) =>
  `market_experiment_${experimentId}`

export const getExperimentCookie = ({
  experimentId,
  consentType,
  defaultValue
}: {
  experimentId: string
  consentType: Consent
  defaultValue?: string
}) => {
  if (!userHasOptedOutOfCookiesForCategory(consentType)) {
    const experimentCookieKey = getExperimentCookieName(experimentId)
    return Cookies.get(experimentCookieKey) || defaultValue
  }

  return defaultValue
}

export const setExperimentCookie = ({
  experimentId,
  itemValue,
  consentType,
  cookieOptions
}: {
  experimentId: string
  itemValue: string
  consentType: Consent
  cookieOptions?: ICookieOptions
}) => {
  if (!userHasOptedOutOfCookiesForCategory(consentType)) {
    const experimentCookieKey = getExperimentCookieName(experimentId)
    Cookies.set(experimentCookieKey, itemValue, cookieOptions)
  }
}
